function showDeflectionCheckSummary() {
  //get service case results...
  var design = activeProject.design;
  var checks = g_results["deflection_checks"];
  var controlling_unity = checks["controlling_unity"];
  var controlling_case = checks["controlling_case"];
  var max_dy = checks["max_dy"];
  var success = controlling_unity < 1.0;
  var designStatusStr = success ? '<i class="fa-solid fa-check text-success"></i>' : '<i class="fa-solid fa-xmark text-danger"></i>';
  setDesignPanelSuccessOrFail(success, '#deflection-design-panel');

  let str = String.raw`
    <div class="card-header">
        <h4 class="panel-title">
            <span class="float-start">${designStatusStr} Deflection</span>
            <span class="float-end">${controlling_unity.toFixed(2)}</span>
        </h4>
    </div>`
  
  str += "<table class='table'>";

  str += makeSummaryRow('Based On', 'Service Cases')

  str += makeSummaryRow('Controlling Service Case', controlling_case)

  str += makeSummaryRow('Max Dy', `${showSmallLengthWithUnits(max_dy)} = L/${Math.ceil(activeProject.beam.TotalLength()/Math.abs(max_dy)/10)*10}`)

  str += makeSummaryRow('Live Load Limit', `L/${design.liveLoadLimit}`)

  str += makeSummaryRow('Dead + Live Limit', `L/${design.deadPlusLiveLoadLimit}`)

  str += makeSummaryRow('Snow or Wind Limit', `L/${design.snowOrWindLoadLimit}`)

  str += makeSummaryRow('Total Load Limit', `L/${design.totalLoadLimit}`)

  if(activeProject.isEngineeredLumber) {
      str += makeSummaryRow('Shear Deformation Included', "Asx = A(5 + 5&nu;)/(6 + 5&nu;)")
  }
  
  str += "</table>";
  
  document.getElementById("deflection-design-panel").innerHTML = str
}
